export const init = () => {
    if (document.querySelector('.js-fade-window-2')) {

        const fade_window_2_wrap_all = document.querySelectorAll(".js-fade-window-2-wrap");
        let fade_window_2_trigger;
        let fade_window_2_trigger_title;
        let fade_window_2;
        let close_button;
        let init_items;

        const toggle_fade_window_2 = function (title, fade_window) {
            title.classList.toggle("js-rotate");
            fade_window.classList.toggle('active');
        }

        const close_fade_window_2_single = function (title, fade_window) {
            title.classList.remove("js-rotate");
            fade_window.classList.remove('active');
        }

        fade_window_2_wrap_all.forEach(item => {
            fade_window_2_trigger = item.querySelector(".js-trigger-faded-window-2");
            close_button = item.querySelector('.js-close');

            init_items = function (item_include) {
                fade_window_2_trigger_title = item_include.querySelector(".js-fw2-title");
                fade_window_2 = item_include.querySelector('.js-fade-window-2');
            };

            fade_window_2_trigger.addEventListener('click', function (e) {
                e.preventDefault();
                init_items(item);
                toggle_fade_window_2(fade_window_2_trigger_title, fade_window_2);
            })

            close_button.addEventListener('click', function (e) {
                init_items(item);
                close_fade_window_2_single(fade_window_2_trigger_title, fade_window_2);
            });

        })


    }
} 